import { useSessionContext } from '@issuemanager/apps/client/contexts';
import { useFeatureFlags } from '@issuemanager/client/features/users';
import { useEffect } from 'react';

// pendo is a global variable that is injected by the Pendo script
declare const pendo: any;

export function Pendo() {
  const session = useSessionContext();
  const isPendoEnabled = useFeatureFlags('pendo');

  useEffect(() => {
    if (!isPendoEnabled) {
      return;
    }

    if (session && typeof pendo !== 'undefined') {
      const { org_id: orgId, name, email, uid, subdomain } = session;
      const pendoOptions = {
        visitor: {
          id: uid,
          email,
          fullname: name,
        },
        account: {
          id: orgId,
          account_subdomain: subdomain,
        },
      };
      pendo.initialize(pendoOptions);
    }
  }, [session, isPendoEnabled]);

  return null;
}
